document.addEventListener("DOMContentLoaded", function () {
  $(document).on('click', '.show-phone-contact', function () {
    $(this).addClass('hidden');
    $(this).next('.contact-phone').removeClass('hidden');
  });

  $(document).on('click', '.show-phone-garage', function () {
    $(this).addClass('hidden');
    $(this).next('.garage-phone-display').removeClass('hidden');
  });
});
